import { Link, useNavigate } from "react-router";
import { Button } from "../../../app/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../app/components/ui/card";
import { PurchaseOrderForm } from "../components/PurchaseOrderForm";

export function PurchaseOrderCreatePage() {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold text-foreground mb-1">Create purchase order</h1>
          <p className="text-muted-foreground">Choose a dealer and add line items.</p>
        </div>
        <Button asChild variant="outline">
          <Link to="/purchase-orders">Back</Link>
        </Button>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle>New PO</CardTitle>
          <CardDescription>Defaults to Draft until you send it.</CardDescription>
        </CardHeader>
        <CardContent>
          <PurchaseOrderForm mode="create" onSuccess={() => navigate("/purchase-orders")} />
        </CardContent>
      </Card>
    </div>
  );
}
